export default __webpack_public_path__ + "static/media/img5.022bcea8.webp";